module.exports = __webpack_public_path__ + "img/location-company.5f8225d2.svg";